import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
// components
import LoadingScreen from '../../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';
import { useSlugContext } from 'src/hooks/slugProvider';
import { PATHS } from 'src/routes/paths';

// ----------------------------------------------------------------------

const ProfileGuard : React.FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated, isInitialized} = useAuthContext();
  
  const { slug_id: slug } = useSlugContext();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={PATHS.login.view(slug)}/>;
  }

  return <>{children}</>;
}


export default ProfileGuard;